const ID_TOKEN_KEY = "id_token";


export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

    
export const verifyToken = () => {
  //console.log(getToken())
  if(getToken())
        return true
  return false
};


export const saveToken = (token) => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};


export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken ,verifyToken};
